import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { useSwitchState } from 'hooks/useSwitchState'
import { CreatePost, Post } from '@wellesley/openapi'
import { getDisplayUsername } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { Maximize2, X, Minimize2 } from 'lucide-react'

import { PostForm } from '../../../PostForm'
import { PrivacyOptionsVariant } from '../../../PostForm/types'

type TReplyMobileForm = {
  feed: Post
  autoFocus?: boolean
  className?: string
  isDisabledCommentOption?: boolean
  userMentionSearchScope?: {
    groupId?: string
  }
  privacyOptionsVariant?: PrivacyOptionsVariant
  onSubmit: (data: CreatePost) => Promise<void>
  onClose?(): void
}

const ReplyMobileForm: FC<TReplyMobileForm> = ({
  feed,
  className,
  autoFocus = false,
  isDisabledCommentOption,
  userMentionSearchScope,
  privacyOptionsVariant,
  onClose,
  onSubmit,
}) => {
  const [isMobileFullScreen, , , toggleMobileFullScreen] = useSwitchState()

  const [isFocused, , , , setIsFocused] = useSwitchState()

  return (
    <div className={cn('relative bg-white', className)}>
      {isMobileFullScreen && (
        <div className="p-xs flex items-center justify-between border-b border-t border-gray-200 text-base font-bold text-gray-700">
          <Minimize2
            size={24}
            color="var(--gray-400)"
            onClick={toggleMobileFullScreen}
            data-testid="minimize-2"
          />
          New Reply
          <div className="w-6">
            {onClose && (
              <X
                size={24}
                color="var(--gray-400)"
                onClick={onClose}
                data-testid="x"
              />
            )}
          </div>
        </div>
      )}
      {!isMobileFullScreen && (
        <div
          className="right-xs top-xs mt-xs mr-xs absolute z-10 cursor-pointer bg-white"
          onClick={toggleMobileFullScreen}
          data-testid="maximize-2"
        >
          <Maximize2 size={24} color="var(--gray-400)" />
        </div>
      )}
      <div className="p-s">
        <PostForm
          isReply
          autoFocus={autoFocus}
          isCompactField={!isFocused}
          privacyOptionsVariant={privacyOptionsVariant}
          userMentionSearchScope={userMentionSearchScope}
          className={cn({
            'min-h-[80vh]': isMobileFullScreen,
          })}
          pollClassName={
            isMobileFullScreen
              ? '[&>div:first-child]:flex [&>div:first-child]:flex-1 [&>div:first-child_*]:flex [&>div:first-child_*]:flex-1'
              : ''
          }
          onFocusChange={setIsFocused}
          placeholder={`Reply to ${getDisplayUsername(getUserNameWithDomain(feed?.author))}`}
          userName={getDisplayUsername(getUserNameWithDomain(feed?.author))}
          onSubmit={onSubmit}
          submitButtonText="Reply"
          isDisabledCommentOption={isDisabledCommentOption}
        />
      </div>
    </div>
  )
}

export default ReplyMobileForm
